// extracted by mini-css-extract-plugin
export default {"deleteButton_div":"deleteButton_deleteButton_div__Bjjei","ant-menu-item":"deleteButton_ant-menu-item__HhwuZ"};